import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { PostCreated } from '../modal';

export default function reducer(state: PostCreated = new PostCreated(), action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.POST_CREATED_LIST_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.POST_CREATED_LIST_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.POST_CREATED_LIST_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
